import type { Department } from "../engine";
import { GS } from "./gs";
import { OBGYN } from "./obgyn";

/** Title-screen tab order. */
export const DEPARTMENTS: readonly Department[] = [OBGYN, GS];
